// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  --padding-start: 0px;
  --inner-padding-end: 0px;
}

ion-img {
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/country-picker/country-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":["ion-item-divider {\n  --padding-start: 0px;\n  --inner-padding-end: 0px;\n}\n\nion-img {\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
